module.exports = __webpack_public_path__ + "static/media/portal_user_mgmt.c77762e5.svg";